import React from 'react';
import classnames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Switch from 'components/library/Switch';
import withStyles from 'helpers/withStyles';
import { testProps } from 'utils/test/testProps';
import MaterialUiField from '../MaterialUiField';

const styles = theme => ({
  switch: {
    alignSelf: 'flex-start',
  },
  errorSwitch: {
    color: theme.palette.error.main,
  },
  label: {},
});

const MuiSwitchField = ({
  className,
  fullWidth,
  name,
  value,
  label,
  color = 'primary',
  onChange,
  children,
  helperText,
  error,
  classes,
  ...props
}) => (
  <FormControl className={className} fullWidth={fullWidth}>
    <FormControlLabel
      control={
        <Switch
          className={classnames(classes.switch, error && classes.errorSwitch)}
          name={name}
          color={color}
          checked={value}
          onChange={onChange}
          {...testProps(name)}
        />
      }
      label={
        <div className={classes.label}>
          {children || label}
          {helperText &&
            <FormHelperText error>{helperText}</FormHelperText>
          }
        </div>
      }
    />
  </FormControl>
);

const MuiSwitchFieldWithStyles = withStyles(styles)(MuiSwitchField);

const SwitchField = ({ ...props }) => (
  <MaterialUiField {...props} muiComponent={MuiSwitchFieldWithStyles}  />
);

export default SwitchField;
